import css from './FormButtons.module.css';

function FormButtons({children}) {
    return <div className={css.formButtons}>{children.map(x => x)}</div>;
}

export default FormButtons;
